/**
 * DEMO-ONLY: SKUs whose storefront price is available only upon request (MVP 2.4.7).
 * Product fixtures also set `priceOnRequest: true`; this set keeps mock basket pricing in sync.
 */
export const PRESIDIO_DEMO_PRICE_ON_REQUEST_SKUS = new Set<string>(
  ['DELL-AI-STOR-60', 'CT8G4DFRA32', 'CT16G56C46S5', 'M321R4GA3BB0', 'M321R8GA0BB0', 'KSM56R46BD4'].map(s =>
    s.toUpperCase()
  )
);

export function isDemoPriceOnRequestSku(sku: string | undefined | null): boolean {
  if (!sku) {
    return false;
  }
  return PRESIDIO_DEMO_PRICE_ON_REQUEST_SKUS.has(sku.trim().toUpperCase());
}
